import Image from 'next/image';
import { useMemo } from 'react';
import { NETWORKS } from 'src/common/types/network';

import useGetChainInfo from '@/hooks/useGetChainInfo';
import { getAddressScannerUrl, maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const MorphoVaultsTriggerDetails = ({ trigger, triggerType }: Props) => {
  const { getChainIconUrl } = useGetChainInfo();

  const vaultAddress = trigger.context?.vault ?? '';
  const chainId = trigger.context?.chain_id;

  const networkInfo = useMemo(() => {
    if (!chainId) return null;
    return NETWORKS.find((network) => network.chainId === chainId);
  }, [chainId]);

  const scannerUrl = useMemo(() => {
    if (!vaultAddress || !networkInfo) return '';
    return getAddressScannerUrl('chainId', networkInfo.chainId, vaultAddress) || '';
  }, [vaultAddress, networkInfo]);

  const chainIconUrl = useMemo(() => {
    if (!networkInfo) return '';
    return getChainIconUrl(networkInfo.chainId) || '';
  }, [networkInfo, getChainIconUrl]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Vault"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            {chainIconUrl && <Image src={chainIconUrl} width={12} height={12} alt={networkInfo?.name || 'chain'} />}
            <span>{maskAddressValue(vaultAddress) ?? ''}</span>
          </div>
        }
        href={scannerUrl}
      />
    </div>
  );
};
